<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="开始日期">
                <el-date-picker
                        v-model=formInline.sendDate
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
                <el-button type="success" @click="handleTest">测试redisExpire</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="logList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
          <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="level" label="等级" width="200"></el-table-column>
            <el-table-column prop="totalNum" label="该等级人数"></el-table-column>
            <el-table-column prop="failNum" label="推送人数"></el-table-column>
            <el-table-column prop="succNum" label="推送成功人数"></el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="添加会员等级" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="等级">
                    <template>
                        <el-checkbox-group v-model="form.levels">
                            <el-checkbox label="1"></el-checkbox>
                            <el-checkbox label="2"></el-checkbox>
                            <el-checkbox label="3"></el-checkbox>
                            <el-checkbox label="4"></el-checkbox>
                            <el-checkbox label="5"></el-checkbox>
                            <el-checkbox label="6"></el-checkbox>
                            <el-checkbox label="7"></el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-form-item>
                <el-form-item label="发送时间">
                    <el-date-picker
                            v-model="form.sendTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addSend(form)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getVipDaySendRecord,sendVipDayNotice,testRedisExpire} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                logList:[],
                loading:true,
                selectValue: '',
                dialogFormVisible:false,
                form:{
                    levels:[],
                    sendTime:""
                },
                formInline:{
                    sendDate:"",
                    currentPage:1,
                    recordsTotal:0,
                    pageSize:10,
                }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                getVipDaySendRecord(this.formInline).then((res) => {
                    this.loading = false;
                    this.logList = res.data.value;
                    this.formInline.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },
            handleAdd(){
                this.form={
                    levels:[],
                    sendTime:""
                }
                this.dialogFormVisible = true;
            },
            handleTest(){
                testRedisExpire({}).then((res) => {
                     if(res.data.status==200){
                         this.$message({
                             showClose: true,
                             message: '成功',
                             type: 'success'
                         });
                         this.dialogFormVisible = false;
                     }else{
                         this.$message({
                             showClose: true,
                             message: res.data.message,
                             type: 'error'
                         });
                     }
                })
            },
            addSend(form){
                console.log(form);
                var levelStr = "";
                for (var i = 0; i <form.levels.length; i++){
                    levelStr = levelStr + form.levels[i] + ",";
                    console.log(form.levels[i]);
                }
                if(form.levels.length == 0){
                    this.$message({
                        showClose: true,
                        message: '请选择等级',
                        type: 'success'
                    });
                }
                form.levels = levelStr;

                sendVipDayNotice(form).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList(this.currentPage,this.pageSize);
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/vip/vipDaySendLog.vue